// Partial — admin/robot-analysis routes.
// Covers: /admin/robot-analysis (controle + observabilidade da análise IA PRO).
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminRobotAnalysisPage = lazyWithRetry(
  () => import("./pages/AdminRobotAnalysisPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/robot-analysis", Component: AdminRobotAnalysisPage },
    ],
  },
];

export default routes;
